import React from 'react';
import { Modal, Button } from '@design-system';
import { CheckIcon } from '@design-system';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

export const SuccessModal = ({ primaryColor, handleSignRedirect, isOpen }) => {
  const { t } = useTranslation();
  return (
    <Modal
      className="py-0"
      closeOnClickOutside={false}
      setShowModal={handleSignRedirect}
      showButtons={false}
      showCancel={false}
      showModal={isOpen}
      width="md:w-80">
      <>
        <CheckIcon
          className="mx-auto mb-3"
          color={primaryColor}
          height={101}
          width={101}
        />

        <p className="mb-10 text-center text-h4 font-bold">
          <span>{t(translations.MODALS.DOCUMENT_CREATED_SUCCESS)} </span>
          <span className="text-primary-300" style={{ color: primaryColor }}>
            {t(translations.COMMON.SUCCESSFULLY)}
          </span>
        </p>

        <div className="flex flex-col items-center">
          <Button
            className="px-8 text-white mb-4"
            size="sm"
            onClick={handleSignRedirect}
            variant="solid"
            color={primaryColor}>
            {t(translations.COMMON.CONTINUE)}
          </Button>

          <a
            href="/changelog"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[10px] text-gray-400 hover:text-gray-600 transition-colors uppercase tracking-widest font-semibold"
          >
            Ver novedades
          </a>
        </div>
      </>
    </Modal>
  );
};
